import React from "react";
import {StyledMyCardContainer} from "./MyCard.styles";

export const MyCard = ({children, ...props}) => (
    <StyledMyCardContainer {...props}>
        {children}
    </StyledMyCardContainer>
)